import { useQuery } from "@tanstack/react-query";
import { getBrevoMappings } from "../../api/bBrevoApi";

export const useGetBrevoMappings = (organisationId) => {
  return useQuery({
    queryKey: ["brevo-mappings", organisationId],
    queryFn: () => getBrevoMappings(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    onError: (error) => {
      console.error("Error fetching Brevo mappings:", error.response || error);
    },
  });
};
